import React from 'react';
export function Pricing() {
  return <section className="relative py-8 px-3 overflow-hidden" data-id="element-210"></section>;
}